<div id="flight-2" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header align-content-center align-items-center ">
                <h5 class="modal-title">Cruise Online Booking</h5>
                <button type="button" id="closeModal" class="close " data-dismiss="modal" aria-label="Close"> <span
                        aria-hidden="true">&times;</span> </button>
            </div>
            <div class="modal-body pt-0">
                <div class="tab-pane fade show active search_field_box" id="hotels" role="tabpanel"
                    aria-labelledby="hotels-tab">
                    <form id="bookingHotels" method="post" autocomplete="off">
                        <div class="row no-gutters search-input-2">
                            <div class="col-lg-5 col-md-12 col-sm-12 form-group">
                                <h5>Search Destinations/River</h5>
                                <input type="text" name="place" class="form-control" [(ngModel)]="place"
                                    (keyup)="getLocations($event)" (click)="makeItBlank($event)" id="hotelsFrom"
                                    required placeholder="Enter City" autocomplete="off">
                                <!-- <div class="locations"> -->
                                <div id="autocomplete-list" class="autocomplete-items">
                                    <div *ngFor="let l of locations" (click)="setLocation(l.Destination)">
                                        <strong>{{l.Destination}}</strong>
                                    </div>
                                    <!-- </div> -->
                                </div>
                            </div>
                            <div class="divider"></div>
                            <div class="col-lg-2 col-md-6 col-sm-6 form-group">
                                <h5 class="pd_left"><span class="icon-inside"><i class="far fa-calendar-alt"></i></span>
                                    Dates</h5>
                                <select class="custom-select" name="sailDate" [(ngModel)]="sailDate" id="hotelsCheckIn"
                                    required>
                                    <option [ngValue]="''">Sail Months</option>
                                    <option *ngFor="let sm of sailMonths" [ngValue]="sm.month">{{sm.month}}</option>
                                </select>
                            </div>
                            <div class="divider"></div>
                            <div class="col-lg-2 col-md-2">
                                <button (click)="filterData()" class="search_btn" type="button">Apply</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>